import prepareComponent from "@bluframe/grapple/prepareComponent"
import { Props as JobTriggerPanelProps } from "components/Socials/JobTriggerPanel"

import JobTriggers from "./JobTriggers"

export interface Props extends JobTriggerPanelProps {}

export interface ComponentProps extends Props {}

const usePrepareComponent = (props: Props): ComponentProps => {
  return {
    ...props
  }
}

export default prepareComponent<Props, ComponentProps>(usePrepareComponent)(
  JobTriggers
)
